import { debug } from "../../utils";

export const ACTION_REMEDIATION_CHANGED = "ACTION_REMEDIATION_CHANGED";
export const ACTION_STATE_CLEANED = "ACTION_STATE_CLEANED";

const initState = {
    remediations: [],
}

export function RemediationPageReducer(state = initState, action) {
    switch (action.type) {
        case ACTION_REMEDIATION_CHANGED: {
            debug(`ManageParametersPageReducer ${ACTION_REMEDIATION_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_STATE_CLEANED: {
            debug(`ManageParametersPageReducer ${ACTION_STATE_CLEANED} is being processed...`)
            return initState;
        }
        default:
            return state;
    }
}
